import api from '../httpClient';

export const submitBugReport = (data: {
  feedback_text: string;
  metadata?: Record<string, unknown> | null;
}) => api.post('/api/bug-reports/', data);

export const getUserBugReports = () =>
  api.get('/api/bug-reports/').then((response) => response.data);
